import { Lock } from 'lucide-react';
import { NavLink } from 'react-router-dom';

import { useAuth } from '../auth/AuthContext';
import { clientHasTierAccess } from '../lib/packageGating';

import { BOOKINGS, HOME, QUESTIONNAIRES, REPORT } from './navItems';

import { cn } from '@/lib/utils';

const ITEMS = [HOME, REPORT, QUESTIONNAIRES, BOOKINGS];

/** Mobile-only tab bar (below the `lg:` breakpoint) that replaces the
 * sidebar/drawer as primary navigation on a phone-sized viewport — the
 * standard installed-PWA pattern. Reuses the same nav-item constants as the
 * desktop sidebar so the two never drift apart. Hidden via CSS (`lg:hidden`)
 * rather than `useIsMobile()` so it never has to reconcile with the
 * sidebar's own mobile/desktop branch. */
export function BottomNav(): JSX.Element {
  const { client } = useAuth();

  return (
    <nav
      aria-label="Primary"
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 flex items-stretch justify-around bg-background/95 backdrop-blur border-t border-border pb-[env(safe-area-inset-bottom)]"
    >
      {ITEMS.map(({ to, label, icon: Icon, end, requiredTier }) => {
        const locked = requiredTier !== undefined && !clientHasTierAccess(client, requiredTier);
        return (
          <NavLink
            key={to}
            to={to}
            end={end ?? false}
            className={({ isActive }) =>
              cn(
                'relative flex flex-1 flex-col items-center justify-center gap-0.5 py-2.5 text-[11px] font-medium transition-colors',
                isActive
                  ? 'text-primary'
                  : locked
                    ? 'text-muted-foreground/50'
                    : 'text-muted-foreground',
              )
            }
          >
            <Icon className="w-5 h-5" />
            <span>{label}</span>
            {locked && <Lock className="absolute top-1.5 right-[calc(50%-1.25rem)] w-2.5 h-2.5" />}
          </NavLink>
        );
      })}
    </nav>
  );
}
